
import api from "."

const tooltips = {
	"Сегмент 1" : "Сегмент 1 СХ использование",
	"Сегмент 2" : "Сегмент 2 Жилая застройка",
	"Сегмент 3" : "Сегмент 3 Общественное использование",
	"Сегмент 4" : "Сегмент 4 Предпринимательство",
	"Сегмент 5" : "Сегмент 5 Отдых (рекреация)",
	"Сегмент 6" : "Сегмент 6 Производственная деятельность",
	"Сегмент 7" : "Сегмент 7 Транспорт",
	"Сегмент 8" : "Сегмент 8 Обеспечение обороны и безопасности",
	"Сегмент 9" : "Сегмент 9 Охраняемые природные территории и благоустройство",
	"Сегмент 10" : "Сегмент 10 Использование лесов",
	"Сегмент 11" : "Сегмент 11 Водные объекты",
	"Сегмент 12" : "Сегмент 12 Специальное, ритуальное использование, запас",
	"Сегмент 13" : "Сегмент 13 Садоводство и огородничество, малоэтажная жилая застройка",
	"Сегмент 14" : "Сегмент 14 Иное использование",

	"Группа 1" : "Группа 1 Средне- и многоэтажная жилая застройка",
	"Группа 2" : "Группа 2 Малоэтажная и индивидуальная жилая застройка",
	"Группа 3" : "Группа 3 Хранение транспорта",
	"Группа 4" : "Группа 4 Коммерческое назначение",
	"Группа 5" : "Группа 5 Объекты временного проживания",
	"Группа 6" : "Группа 6 Административные и бытовые объекты",
	"Группа 7" : "Группа 7 Производственное назначение",
	"Группа 8" : "Группа 8 Общественное назначение",
	"Группа 9" : "Группа 9 Прочие объекты",
	"Группа 10" : "Группа 10 Сооружения",
}

function get_groups_tree(self, node, parent_full_name, parent_id)
{
	var children = []
	var full_name
	var tooltip

	if (parent_full_name == "Земельные участки" || parent_full_name == "Объекты недвижимости, за исключением земельных участков" )
		tooltip = tooltips[node.name]

	if(parent_full_name == null)
		full_name = node.name
	else
		full_name = `${parent_full_name} / ${node.name}`

	node.children.forEach(sub_node => children.push(get_groups_tree(self, sub_node, full_name, node.id)))

	const objects_count = api.number_to_string_with_ranking(node.objects_count)
	var objects_text = `${node.name} (${objects_count})`
	
	const analogues_count = api.number_to_string_with_ranking(node.analogues_count)
	var analogues_text = `${node.name} (${analogues_count})`

	const objects_key = "ОО_" + node.id
	const analogues_key = "ОА_" + node.id

	const objects_route_data = self.$router.resolve(
	{
		name : "objects",
		query :
		{
			query : JSON.stringify({ "and" : [ { keys : [ "cadastral_group" ], operation : "cadastral_group", args : [ node.id, full_name ] } ]}),
			key : objects_key,
		},
	})

	const analogues_route_data = self.$router.resolve(
		{
			name : "analogues",
			query :
			{
				query : JSON.stringify({ "and" : [ { keys : [ "cadastral_group" ], operation : "cadastral_group", args : [ node.id, full_name ] } ]}),
				key : analogues_key,
			},
		})

	var is_fixed = node.name == "Земельные участки" || node.name == "Объекты недвижимости, за исключением земельных участков" || Object.keys(tooltips).includes(node.name)

	node.has_cost_evaluation = node.cost_evaluation_profitable != null || node.cost_evaluation_expensive != null || node.cost_evaluation_comparative != null || node.cost_evaluation_individual != null
	node.has_cost_evaluation_profitable = node.cost_evaluation_profitable != null
	node.has_cost_evaluation_expensive = node.cost_evaluation_expensive != null
	node.has_cost_evaluation_comparative = node.cost_evaluation_comparative != null
	node.has_cost_evaluation_individual = node.cost_evaluation_individual != null

	var desc = {

		// id не указываем, чтобы группу в группах можно было найти по нему
		text :  node.name,
		
		data :
		{			
			group_id : node.id,
			tooltip : tooltip,

			full_name,

			objects_text,
			objects_url : objects_route_data.href,
			objects_key : objects_key,

			analogues_text,
			analogues_url : analogues_route_data.href,
			analogues_key : analogues_key,

			group_url : "/groups/" + node.id,

			has_cost_evaluation : node.has_cost_evaluation,
			has_cost_evaluation_profitable : node.has_cost_evaluation_profitable,
			has_cost_evaluation_expensive : node.has_cost_evaluation_expensive,
			has_cost_evaluation_comparative : node.has_cost_evaluation_comparative,
			has_cost_evaluation_individual : node.has_cost_evaluation_individual,
			cost_evaluation_comparative_model_imported : node.cost_evaluation_comparative_model_imported,
			is_fixed,
			objects_count : node.objects_count,
			parent_id,
			not_editable : self.$root.not_editable //TODO
		}

	}

	if(children.length)
		desc.children = children

	return desc
}

async function create(self, set_model = true)
{
	var main_tree_groups =	[]
	var main_tree =	[]
	var has_parcel = false
	var has_oks = false
	// var children = []

	return api.load_roles(self).then(
		() =>
		{
			var add_to_main_tree =
				desc =>
				{
					if( desc.data != null || ( desc.children != null && desc.children.length ))
						main_tree.push(desc)
				}
			
			var add_to_children_tree = ( tree, desc ) => tree.push(desc)
			
			/*
			var add_empty_line_to_main_tree =
				() =>
				{
					main_tree.push({ state : { selectable : false, disabled : true } })
				}
			*/

			// children = []

			// add_to_children_tree(children,
			// 	{
			// 		text : "Объекты-аналоги",
			// 		data : { url : "/expensive" },
			// 	})

			var sub_children = []

			/*
			add_to_children_tree(sub_children,
				{
					text : "Справочник УНЦС",
					data : { url : "/books" },
				})
			*/

			/* 4375
			add_to_children_tree(sub_children,
				{
					text : "Поправки на площадь и объем",
					data : { url : "/corrections_area_volume" },
				})
			*/

			add_to_children_tree(sub_children,
				{
					text : "Данные для расчета строительного объема",
					data : { url : "/floor_height" },
				})
			
			add_to_children_tree(sub_children,
				{
					text : "Региональные коэффициенты",
					data : { url : "/region_coefs" },
				})

			/*
			add_to_children_tree(sub_children,
				{
					text : "Населенные пункты",
					data : { url : "/cities" },
				})
			*/

			add_to_children_tree(sub_children,
				{
					text : "Справочник сейсмичности",
					data : { url : "/seismicity_alpha" },
				})

			add_to_children_tree(sub_children,
				{
					text : "Срок экономической жизни",
					data : { url : "/min_age_buildings" },
				})

			add_to_main_tree(
				{
					text : "Справочные данные",
					children : sub_children,
					data : { url : "#", key : "Справочные данные" },
				})

			// add_to_main_tree( 
			// 	{
			// 		text : "Затратный подход",
			// 		children : children,
			// 		data : { url : "#" },
			// 	})

			add_to_main_tree(
				{
					key : "cost_evaluations",
					text : "Реестр моделей оценки КС",
					data : { url : "/cost_evaluations" },
					children : []
				})

			/*
			if(api.check_roles(self, [ "cost" ]))
				add_to_main_tree(
					{
						key : "data_fund",
						text : "Закончить расчет",
						data :
						{
							callback : self => api.call_long_operation(self, "Экспорт", "cadastral", "export", {}, api.open_response_url)
						}
					})
			*/

			/*
			add_to_main_tree(
				{
					key : "dev",
					text : "Разработка",
					data : { url : "/dev" }
				})
			*/
		})
	.then(
		() => api.call(self, "cadastral_groups", "root", {},
				response =>
				{
					main_tree_groups = []
					
					response.data.children_tree.children.forEach(
						elem =>
						{
							if(elem.is_parcel)
								has_parcel = true

							if(elem.is_oks)
								has_oks = true

							main_tree_groups.push(get_groups_tree(self, elem, null, null))
						})
				})
		)
	.then(() =>
	{
		if(! has_oks)
			delete main_tree[0]

		self.$localStorage.set(api.storage.procedure_name("has_parcel"), has_parcel)
		self.$localStorage.set(api.storage.procedure_name("has_oks"), has_oks)
		self.$localStorage.set(api.storage.procedure_name("main_tree"), JSON.stringify({
			"main_tree_groups": main_tree_groups,
			"main_tree": main_tree,
		}))
		self.$root.$children[0].set_main_tree({
			"main_tree_groups": main_tree_groups,
			"main_tree": main_tree,
		}, set_model)
	})
}

function get(self)
{
	var raw = self.$localStorage.get(api.storage.procedure_name("main_tree"), null, String)

	if(raw == null)
		return []

	return JSON.parse(raw)
}

export default 
{
	create,
	get,
}

